import { render, staticRenderFns } from "./MetodoTrabalho.vue?vue&type=template&id=0069e0b2&scoped=true"
import script from "./MetodoTrabalho.vue?vue&type=script&lang=js"
export * from "./MetodoTrabalho.vue?vue&type=script&lang=js"
import style0 from "./MetodoTrabalho.vue?vue&type=style&index=0&id=0069e0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069e0b2",
  null
  
)

export default component.exports